import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { TertiaryButton, TextField } from '../AtomComponents';
import { onlyNumberKey } from './Utils';
import { InputAdornment } from '@material-ui/core';

function MaxAwardForNewFulfilled(props: any, ref: any) {
  const [maxAwardValue, setMaxAwardValue] = useState<string>('100');
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;

    if (+value > 100) return;
    setMaxAwardValue(e.target.value);
  };

  function onBlur(e: any) {
    const { value } = e.target;
    if (!+value) setMaxAwardValue('100');
  }

  function clearCurrentValue() {
    setMaxAwardValue('100');
  }

  useImperativeHandle(ref, () => {
    function getCurrentMaxValue() {
      return maxAwardValue;
    }
    return { getCurrentMaxValue };
  });

  return (
    <>
      <div className="margin-left-2 margin-bottom-2" style={{ width: '150px' }}>
        Max % of Award for New Fulfilled
      </div>
      <TextField
        className="margin-left-2 margin-bottom-2 max-award-field"
        name="maxAward"
        type="number"
        inputProps={{ min: 1, step: 1 }}
        value={maxAwardValue}
        onBlur={onBlur}
        onKeyPress={onlyNumberKey}
        onChange={handleChange}
        InputProps={{
          endAdornment: <InputAdornment position="end">%</InputAdornment>,
        }}
        size="small"
        style={{ width: '100px' }}
      />
      <TertiaryButton className="margin-left-1 margin-bottom-2" onClick={clearCurrentValue}>
        CLEAR
      </TertiaryButton>
    </>
  );
}

export default forwardRef(MaxAwardForNewFulfilled);
